import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, Grid, IconButton, InputAdornment, TextField, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import EditorImagemApp from "app/Core/Components/EditorImagem/EditorImagemApp";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import classNames from "classnames";
import md5 from "js-md5";
import MobileDetect from "mobile-detect";
import React from "react";
import { AiOutlineCloudSync } from "react-icons/ai";
import { MdAdd, MdClose, MdCloudDone, MdCloudOff, MdCloudUpload, MdRemove } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { pad } from "app/Core/Helpers";
import XAPPButton from "../../Core/Components/Button/XAPPButton";
import ConfirmacaoApp from "../../Core/Components/Confirmacao/ConfirmacaoApp";
import LogRegistro from "../../Core/Components/LogRegistro/LogRegistroApp";
import EmpresaPessoaApp from "../../ERP/EmpresaPessoa/EmpresaPessoaApp";
import EmpresaProdutoApp from "../../ERP/EmpresaProduto/EmpresaProdutoApp";
import * as Actions from "./Store/Actions/ArquivoActions";
import Loading from "@fuse/components/FuseLoadable/Loading";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        height: "57px",
        border: "1px solid " + theme.palette.divider,
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        width: 1,
        height: 28,
        margin: 4,
    },
    spanlabel: {
        top: 9,
        left: 15,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
        color: theme.palette.text.secondary,
        maxWidth: "80px",
    },
    rootTheme: {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
    },
    paper: {
        padding: "3px",
        display: "flex",
        alignItems: "center",
        border: "1px solid " + theme.palette.divider,
    },
    GridItemSwitch: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        color: theme.palette.text.primary,
    },
    log: {
        padding: "8px",
        border: "solid 1px #ccc",
        color: "white",
        borderRadius: "5px",
        fontSize: "14px",
    }
});

const newArquivoState = {
    idarquivo: null,
    pasta: null,
    idpessoa: null,
    nome: null,
    descricao: null,
    tipo: null,
    idfuncionalidade: null,
    files: null,
    compartilhar: 0,
    log: "Pendente"
};

class ArquivoModel {
    constructor(props) {
        this.id = md5(new Date().getTime().toString());
        this.descricao = null;
        this.status = 0;
        this.compartilhar = 0;
        this.name = null;
        this.file = null;
        this.file64 = null;
        this.filetype = null;
        this.isImage = props.isImage;
    }
}

class ArquivoDialog extends XAPPComponent {

    state = { ...newArquivoState, idpessoa: this.props.xappRouteParams.empresa };

    //status 0 não enviado
    //status 1 enviado com sucesso
    //status 2 falha ao enviar

    componentDidUpdate(prevProps, prevState) {
        if (this.props.Arquivo.error) {
            this.props.showMessage({
                message: this.props.Arquivo.error,
                variant: "error"
            });
            this.props.Arquivo.error = null;
        }
        if (this.props.Arquivo.warning) {
            this.props.showMessage({
                message: this.props.Arquivo.warning,
                variant: "warning"
            });
            this.props.Arquivo.warning = null;
        }
        if (this.props.Arquivo.info) {
            this.props.showMessage({
                message: this.props.Arquivo.info,
                variant: "success"
            });
            this.props.Arquivo.info = null;
        }
        if (this.props.formDialog.props.info) {
            this.props.showMessage({
                message: this.props.formDialog.props.info,
                variant: "success"
            });
            this.props.formDialog.props.info = null;

            if (this.props.formDialog.props.id !== null) {
                this.atualizarStatus(this.props.formDialog.props.id, this.props.formDialog.props.nome, 1);
                this.Upload();
            }
        }
        if (this.props.formDialog.props.error) {
            this.props.showMessage({
                message: this.props.formDialog.props.error,
                variant: "error"
            });
            this.props.formDialog.props.error = null;
            this.atualizarStatus(null, this.props.formDialog.props.nome, 2);
            this.Upload();
        }

        if (!prevProps.formDialog.props.open && this.props.formDialog.props.open) {
            if (this.props.formDialog.type === "edit" &&
                this.props.formDialog.data &&
                !_.isEqual(this.props.formDialog.data.idarquivo, prevState.idarquivo)) {
                this.setState(Object.assign({}, newArquivoState, this.props.formDialog.data));
            }

            if (this.props.formDialog.type === "new") {
                var obj = { ...newArquivoState };
                obj.idpessoa = this.props.xappRouteParams.empresa;
                obj.tipo = this.props.arquivoState.tipo;
                obj.idfuncionalidade = this.props.idfuncionalidade;
                obj.files = [];
                obj.files.push(new ArquivoModel({ isImage: this.props.formDialog.props.isImage }));
                this.setState(obj);
            }
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    closeComposeDialog = () => {
        this.props.formDialog.type === "edit" ? this.props.closeEditDialog() : this.props.closeNewDialog();
    };

    canBeSubmitted() {
        const { files, idfuncionalidade } = this.state;
        var ACan = true;
        if (!_.isUndefined(files) && !_.isNull(files)) {
            files.forEach(item => {
                if (item.isImage === 0 && (item.descricao === null || item.descricao.length < 1 || item.file === null)) {
                    ACan = false;
                }
                else if (item.isImage === 1 && (item.descricao === null || item.descricao.length < 1 || item.file64 === null)) {
                    ACan = false;
                }
            });
        }
        else {
            ACan = false;
        }
        return ACan && idfuncionalidade !== null;
    }

    excluir = () => {
        this.props.remove(this.state, this.props.xappRouteParams);
        this.closeComposeDialog();
    };

    atualizarStatus = (_AID, _ANome, _AStatus) => {
        var { files } = this.state;
        if (!_.isUndefined(files) && !_.isNull(files)) {
            files.forEach(item => {
                if (item.nome === _ANome) {
                    item.status = _AStatus;
                    item.idarquivo = _AID;
                }
            });
        }
        this.setState(_.set({ ...this.state }, "files", files));
    };

    handleFiles(_AItem, _Campo, _AValue) {
        var { files } = this.state;
        if (!_.isUndefined(files) && !_.isNull(files)) {
            files.forEach(item => {
                if (_.isEqual(item, _AItem) && _AValue !== undefined) {
                    if (_Campo === "file") {
                        item.name = _AValue.name;
                        item.isImage = 0;
                        item.filetype = _AValue.type.includes("image/") ? "image/jpg" : _AValue.type;
                    }
                    item[_Campo] = _AValue;
                }
            });
        }
        this.setState(_.set({ ...this.state }, "files", files));
    }

    handleClick = (_AOperador) => {

        var { files } = this.state;
        if (files === null) {
            files = [];
        }

        if (_AOperador === "mais") {
            files.push(new ArquivoModel({ isImage: this.props.formDialog.props.isImage }));
        }
        else {
            files.pop();
        }
        this.setState(_.set({ ...this.state }, "files", files));
    };

    Download = () => {
        var { user, xappRouteParams } = this.props;
        this.props.downloadFile(this.state, xappRouteParams.empresa);
    };

    Preview = () => {
        var { user, xappRouteParams } = this.props;
        this.props.previewFile(this.state, xappRouteParams.empresa);
    };

    Upload = () => {
        var { files, tipo } = this.state;
        var { user, xappRouteParams, arquivoState } = this.props;
        var AIDEmpresa = xappRouteParams.empresa;

        let ASelectedFile = null;
        if (!_.isUndefined(files) && !_.isNull(files)) {
            files.forEach(item => {
                if (item.status === 0) {
                    ASelectedFile = item;
                    return;
                }
            });
        }

        if (!_.isNull(ASelectedFile)) {
            this.setState(_.set({ ...this.state }, "log", "Enviando..."));
            const md5 = require("js-md5");
            var hash = md5(new Date().toISOString());
            var Ano = pad(new Date().getFullYear());
            var Mes = pad(new Date().getMonth());
            var Dia = pad(new Date().getDate());
            ASelectedFile["nome"] = "Arquivos/" + tipo + "/" + Ano + "/" + Mes + "/" + Dia + "/" + hash + "_" + ASelectedFile.name;
            let obj = JSON.parse(JSON.stringify(this.state));
            obj.pasta = arquivoState.pasta;
            if (!_.isUndefined(this.state.pasta) && !_.isNull(this.state.pasta)) {
                obj.pasta = arquivoState.pasta + "/" + this.state.pasta;
            }
            this.props.uploadFile(ASelectedFile, this.props.xappRouteParams, obj, AIDEmpresa);
            this.atualizarStatus(null, ASelectedFile.nome, 3);
        }
        else {
            if (_.findIndex(files, { status: 2 }) >= 0) {
                this.setState(_.set({ ...this.state }, "log", "Erro ao enviar arquivos"));
            }
            else {
                this.setState(_.set({ ...this.state }, "log", "Enviado com sucesso"));
            }
        }
    };

    getIcon = (_AStatus) => {
        switch (_AStatus) {
            case 0:
                return (
                    <MdCloudUpload className="text-32 arrow-icon text-grey" />
                );
            case 1:
                return (
                    <MdCloudDone className="text-32 arrow-icon text-green" />
                );
            case 2:
                return (
                    <MdCloudOff className="text-32 arrow-icon text-red" />
                );
            case 3:
                return (
                    <AiOutlineCloudSync className="text-32 arrow-icon text-blue" />
                );

            default:
                return (
                    <div />
                );
        }

    };

    uploadPending = () => {
        var { files } = this.state;
        var AExist = false;
        if (!_.isUndefined(files) && !_.isNull(files)) {
            files.forEach(item => {
                if (item.status === 0) {
                    AExist = true;
                }
            });
        }
        return AExist;
    };

    handleSwitch = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.checked === true ? 1 : 0));
    };

    setImageEdited = (_AID, _AFile) => {
        var { files } = this.state;
        if (!_.isUndefined(files) && !_.isNull(files)) {
            files.forEach(item => {
                if (_.isEqual(item.id, _AID)) {
                    item.file64 = _AFile.file;
                    item.name = _AFile.name;
                    item.filetype = "image/jpg";
                }
            });
        }
        this.setState(_.set({ ...this.state }, "files", files));
    };

    handleLookupPessoaFormulario = (_AValue = null) => {
        var obj = Object.assign({}, this.state);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj.idfuncionalidade = _AValue[0].idpessoaformulario;
            obj.nome = _AValue[0].nome;
            this.setState(obj);
        }
        else {
            obj.idfuncionalidade = null;
            obj.nome = null;
            this.setState(obj);
        }
    };

    handleLookupProdutoFormulario = (_AValue = null) => {
        var obj = Object.assign({}, this.state);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj.idfuncionalidade = _AValue[0].idpessoaformulario;
            obj.nome = _AValue[0].nome;
            this.setState(obj);
        }
        else {
            obj.idfuncionalidade = null;
            obj.nome = null;
            this.setState(obj);
        }
    };

    getLookup = (_Atipo) => {
        const { xappRouteParams } = this.props;
        const form = this.state;
        switch (_Atipo) {
            case 118:
                return (
                    <EmpresaPessoaApp
                        className="w-full flex flex-col"
                        xappRouteParams={xappRouteParams}
                        selected={!_.isNull(form.idfuncionalidade) ? [{ ...form, id: form.idfuncionalidade, idpessoaformulario: form.idfuncionalidade }] : []}
                        label={"Pessoa"}
                        id={"LookupArquivoEmpresaPessoa"}
                        campoid={"idpessoaformulario"}
                        camponome={"nome"}
                        onChange={this.handleLookupPessoaFormulario}
                        required={true}
                        isLookup={true}
                        multiSelect={false}
                        readOnly={form.log !== "Pendente"}
                    />
                );
            case 119:
                return (
                    <EmpresaProdutoApp
                        className="w-full flex flex-col"
                        xappRouteParams={xappRouteParams}
                        selected={!_.isNull(form.idfuncionalidade) ? [{ ...form, id: form.idfuncionalidade, idpessoaformulario: form.idfuncionalidade }] : []}
                        label={"Produto"}
                        id={"LookupArquivoEmpresaProduto"}
                        campoid={"idpessoaformulario"}
                        camponome={"nome"}
                        onChange={this.handleLookupProdutoFormulario}
                        required={true}
                        isLookup={true}
                        multiSelect={false}
                        readOnly={form.log !== "Pendente"}
                    />
                );
            default:
                return <div />;
        }
    };

    checkPreview = () => {
        const EXISTS_PREVIEW = ["pdf", "text", "image", "mp4"];
        const form = this.state;
        let AResponse = false;
        if (!_.isUndefined(form.mimetype) && !_.isNull(form.mimetype)) {
            EXISTS_PREVIEW.forEach(item => {
                if (form.mimetype.includes(item)) {
                    AResponse = true;
                }
            });
        }
        return AResponse;
    };

    render() {
        const { formDialog, classes, xappRouteParams, removePreviewFile, showRemover, arquivoState, Arquivo } = this.props;
        const form = this.state;
        return (
            <>
                <XAPPDialog
                    {...formDialog.props}
                    id="ArquivoDialog"
                    onClose={this.closeComposeDialog}
                    fullWidth
                    fullScreen={md.mobile() !== null}
                    maxWidth={formDialog.type === "new" ? "md" : "sm"}
                >

                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {formDialog.type === "new" ? "Novo arquivo" : "Editar arquivo"}
                            </Typography>
                            {formDialog.data && (
                                <LogRegistro
                                    primaryKey={"idarquivo"}
                                    Log={formDialog.data}
                                />
                            )}
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={this.closeComposeDialog}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "p-24" }}>

                        {formDialog.type === "new" &&
                            <React.Fragment>
                                <TextField
                                    className="w-full"
                                    label="Pasta"
                                    id={"pasta"}
                                    name={"pasta"}
                                    value={form.pasta}
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start" className="whitespace-no-wrap">{arquivoState.pasta + "/"}</InputAdornment>
                                    }}
                                />
                                {_.isNull(this.props.idfuncionalidade) &&
                                    this.getLookup(this.state.tipo)
                                }
                                {form.log === "Pendente" &&
                                    <div className="flex mt-8" >
                                        <IconButton
                                            onClick={() => {
                                                this.handleClick("mais");
                                            }}
                                        >
                                            <MdAdd color="action" />
                                        </IconButton>
                                        <IconButton
                                            onClick={() => {
                                                this.handleClick("menos");
                                            }}
                                        >
                                            <MdRemove color="action" />
                                        </IconButton>
                                    </div>
                                }
                            </React.Fragment>
                        }
                        {form.files !== null && form.files.map(item => {
                            return (
                                <React.Fragment>
                                    <div className="w-full sm:flex xs:flex-col">
                                        <TextField
                                            className="my-8 sm:mr-8 sm:w-2/5 xs:m-0 xs:w-full"
                                            label="Nome"
                                            disabled
                                            id={"nome"}
                                            name={"nome"}
                                            value={item.isImage === 1 ? item.name : item.file !== null ? item.file.name : ""}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        <TextField
                                            className="my-8 sm:w-2/5 xs:m-0 xs:w-full"
                                            label="Descrição"
                                            required
                                            id={"descricao"}
                                            name={"descricao"}
                                            value={item.descricao}
                                            onChange={(ev) => this.handleFiles(item, "descricao", ev.target.value)}
                                            variant="outlined"
                                            fullWidth
                                            disabled={item.status !== 0}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {formDialog.type === "new" &&
                                            <div className="sm:w-1/5 my-8 xs:w-full h-56 flex items-end">
                                                <input
                                                    id={"ArquivoInputFile" + item.id}
                                                    type="file"
                                                    // multiple="multiple"
                                                    style={{ display: "none" }}
                                                    onChange={ev => this.handleFiles(item, "file", ev.target.files[0])}
                                                />
                                                <div className="flex-1" />
                                                {item.isImage === 1 && md.mobile() === null &&
                                                    <EditorImagemApp
                                                        file={item.file}
                                                        idfile={item.id}
                                                        callback={this.setImageEdited}
                                                        icon={this.getIcon(item.status)}
                                                    />
                                                }
                                                <IconButton
                                                    className="flex-end"
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        if (item.status === 0) {
                                                            document.getElementById("ArquivoInputFile" + item.id).click();
                                                        }
                                                    }}
                                                >
                                                    {this.getIcon(item.status)}
                                                </IconButton>
                                            </div>
                                        }
                                    </div>
                                </React.Fragment>
                            );
                        })}
                        {formDialog.type === "edit" &&
                            <React.Fragment>
                                {Arquivo.preload ?
                                    <div className="py-56">
                                        <Loading pastDelay={true} />
                                    </div>
                                    :
                                    <React.Fragment>
                                        <Typography color="textSecondary" variant="h6" className="text-16 mb-8">
                                            {"Pasta: " + form.pasta}
                                        </Typography>
                                        <Typography color="textSecondary" variant="h6" className="text-16 mb-8">
                                            {"Nome: " + form.nome}
                                        </Typography>
                                        <Typography color="textSecondary" variant="h6" className="text-16 mb-8">
                                            {"Descrição: " + form.descricao}
                                        </Typography>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </DialogContent>
                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            {formDialog.type === "new" &&
                                <div className={classNames(classes.log, form.log.includes("Pendente") && "bg-grey", form.log.includes("Erro") && "bg-red", form.log.includes("Enviando") && "bg-blue", form.log.includes("sucesso") && "bg-green")}>{form.log}</div>
                            }
                            <div className="flex-1" />
                            <DialogActions className="justify-right gap-4">
                                {formDialog.type === "new" && (
                                    form.log === "Pendente" && this.uploadPending() ?
                                        <XAPPButton
                                            type="Button"
                                            className="bg-blue hover:bg-blue text-white"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                this.Upload();
                                            }}
                                            disabled={!this.canBeSubmitted()}
                                            iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                            icon={"cloud_upload"}
                                            label={md.mobile() === null && md.tablet() === null ? "Upload" : ""}
                                        />
                                        :
                                        <XAPPButton
                                            type="Button"
                                            className="bg-green hover:bg-green text-white"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                this.props.listFilter("SELECIONAR", this.props.xappRouteParams);
                                                this.closeComposeDialog();
                                            }}
                                            disabled={form.log !== "Enviado com sucesso"}
                                            iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                            icon={"done"}
                                            label={md.mobile() === null && md.tablet() === null ? "Ok" : ""}
                                        />
                                )}
                                {formDialog.type === "edit" && this.checkPreview() &&
                                    <XAPPButton
                                        type="Button"
                                        className="bg-grey-darker hover:bg-grey-darker text-white"
                                        variant="contained"
                                        color="primary"
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"eye"}
                                        label={md.mobile() === null && md.tablet() === null ? "Preview" : ""}
                                        onClick={() => this.Preview()}
                                    />
                                }
                                {formDialog.type === "edit" &&
                                    <XAPPButton
                                        type="Button"
                                        className="bg-blue hover:bg-blue text-white"
                                        variant="contained"
                                        color="primary"
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"cloud_download"}
                                        label={md.mobile() === null && md.tablet() === null ? "Download" : ""}
                                        onClick={() => this.Download()}
                                    />
                                }
                                {/* {formDialog.type === "edit" &&
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        update(this.state, xappRouteParams);
                                    }}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                />
                            } */}
                                {formDialog.type === "edit" && showRemover &&
                                    <ConfirmacaoApp
                                        id="Arquivo"
                                        data="Arquivo"
                                        onConfirmation={this.excluir}
                                        mensagem={"Tem certeza que deseja excluir esse registro?"}
                                        xappRouteParams={xappRouteParams}
                                        icon={"delete"}
                                        label={md.mobile() === null && md.tablet() === null ? "Remover" : ""}
                                        className="bg-red hover:bg-red text-white"
                                        type={"button"}
                                    />
                                }
                            </DialogActions>
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
                {formDialog.data?.url &&
                    <XAPPDialog
                        id="ArquivoPreviewDialog"
                        open={true}
                        onClose={removePreviewFile}
                        fullWidth
                        fullScreen={md.mobile() !== null}
                        maxWidth={"md"}
                    >
                        <AppBar position="static" elevation={1}>
                            <Toolbar className="flex w-full min-h-0">
                                <Typography variant="subtitle1 text-white">
                                    {"Preview"}
                                </Typography>
                                <div style={{ flex: 1 }} />
                                <IconButton
                                    key="close"
                                    aria-label="Close"
                                    className="p-6"
                                    onClick={removePreviewFile}
                                >
                                    <MdClose className="text-20 text-white" />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <DialogContent classes={{ root: "p-24" }}>
                            <iframe src={formDialog.data?.url} width={"100%"} height={400}></iframe>
                        </DialogContent>
                    </XAPPDialog>
                }

            </>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeEditDialog: Actions.closeEditDialog,
        closeNewDialog: Actions.closeNewDialog,
        update: Actions.update,
        uploadFile: Actions.uploadFile,
        downloadFile: Actions.downloadFile,
        previewFile: Actions.previewFile,
        removePreviewFile: Actions.removePreviewFile,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
        hideMessage: AppActions.hideMessage,
    }, dispatch);
}

function mapStateToProps({ Arquivo, auth }) {
    return {
        Arquivo: Arquivo,
        formDialog: Arquivo.arquivoDialog,
        user: auth.user.data
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(ArquivoDialog));
